<script>
import CustomCheckbox from "@/components/CustomCheckbox";
import Timepicker from "@/components/Timepicker";
import RadioInputGroup from "@/components/forms/RadioInputGroup";

export default {
    name: "Availability",
    components: {
        Timepicker,
        CustomCheckbox,
        RadioInputGroup,
    },
    props: {
        fromEditService: {
            type: Boolean,
            default: false,
        },
        serviceAvailability: {
            type: Object,
            default: () => {
            },
        },
        errors: {
            type: Object,
            default: () => {
            },
        },
    },
    data() {
        return {
            service: {},
            availabilitySet: "false",

            weekdays: [
                "Sunday",
                "Monday",
                "Tuesday",
                "Wednesday",
                "Thursday",
                "Friday",
                "Saturday",
            ],

            checkedWeekday: [],

            timeErrors: {},
        };
    },
    methods: {
        validate() {
            Object.keys(this.checkedWeekday).map((el) => {
                if (this.checkedWeekday[el].checked) {
                    this.timeErrors[el] = {
                        from: this.checkedWeekday[el].from === "" ? "Please select from time" : "",
                        to: this.checkedWeekday[el].to === "" ? "Please select to time" : "",
                    };
                }
            });

            const errors = Object.keys(this.timeErrors).filter((el) => {
                if (this.timeErrors[el].from !== "" || this.timeErrors[el].to !== "") {
                    return "1";
                }
            });

            return errors.length === 0;
        },
        prevStep() {
            this.$router.push({ name: "Service location" });
        },

        nextStep() {
            const valid = this.validate();
            this.$storage.setStorageSync("checkedWeekday", this.checkedWeekday);
            this.$storage.setStorageSync("availability", this.availabilitySet);
            if (valid) {
                this.$router.push({ name: "Service pricing" });
            }
        },

        toggleWeekday(weekday) {
            const idx = this.checkedWeekday.findIndex((w) => w.weekday === weekday);

            this.checkedWeekday[idx] = {
                ...this.checkedWeekday[idx],
                checked: !this.checkedWeekday[idx].checked,
            };

            this.$emit("updateAvailability", this.service);
        },

        fillCheckedWeekdays() {
            this.checkedWeekday = this.weekdays.map((weekday) => ({
                weekday,
                checked: false,
                from: "",
                to: "",
            }));
        },

        getWeekdayField(weekday, field) {
            const idx = this.checkedWeekday.findIndex((w) => w.weekday === weekday);

            return this.checkedWeekday[idx][field];
        },

        updateTime(weekday, data) {
            const idx = this.checkedWeekday.findIndex((w) => w.weekday === weekday);

            this.checkedWeekday[idx] = {
                ...this.checkedWeekday[idx],
                from: data.start,
                to: data.end,
            };
        },
        getErrors(idx) {
            if (this.fromEditService) {
                return this.errors[idx];
            }

            return this.timeErrors[idx];
        },
    },
    mounted() {
        if (this.fromEditService === true) {
            this.availabilitySet = "true";
            this.service = this.serviceAvailability;
            this.checkedWeekday = this.serviceAvailability.availability;
        } else {
            this.checkedWeekday = this.$storage.getStorageSync("checkedWeekday") || [];
            this.availabilitySet = this.$storage.getStorageSync("availability") || "false";
        }

        if (this.checkedWeekday.length === 0) {
            this.fillCheckedWeekdays();
        }
    },
    watch: {
        checkedWeekday: {
            deep: true,
            handler() {
                this.$emit("updateAvailability", this.service);
            },
        },
    },
};
</script>

<template>
    <div class="availability mx-auto">
        <div class="mt-4 mb-5 service-steps" v-if="!fromEditService">
            Step 4 of 5
        </div>

        <h2 class="mb-5">
            <span v-if="fromEditService">Edit </span>Availability
        </h2>

        <div class="" v-if="!fromEditService">
            <div class="not-filled-step mb-4">Would you like to set your availability?</div>

            <RadioInputGroup
                label="title"
                v-model="availabilitySet"
                :selected="availabilitySet"
                :list="[
                    {
                        title: 'Yes',
                        value: 'true',
                    },
                    {
                        title: 'No',
                        value: 'false',
                    },
                ]"
            />
        </div>

        <h2 class="mt-5" v-if="(availabilitySet === 'true' && !fromEditService)">Working hours</h2>
        <div v-if="availabilitySet === 'true'" class="d-flex flex-column">
            <div
                :key="idx"
                v-for="(weekday, idx) in weekdays"
                class="d-flex flex-row my-3"
            >
                <CustomCheckbox
                    :checked="getWeekdayField(weekday, 'checked')"
                    :hide-margin="true"
                    @checkbox-click="toggleWeekday(weekday)"
                    class="w-25 align-self-center"
                >
                    <div class="d-flex flex-row align-self-center">
                        {{ weekday }}
                    </div>
                </CustomCheckbox>

                <div v-if="!getWeekdayField(weekday,'checked')"
                     class="w-20 not-filled-step unavailable"
                >
                    Unavailable
                </div>
                <div v-else class="">
                    <timepicker
                        @update="updateTime(weekday, $event)"
                        :regular-label="true"
                        :start="getWeekdayField(weekday, 'from') || null"
                        :end="getWeekdayField(weekday, 'to') || null"
                        :options="{
                            startLabel: 'From',
                            endLabel: 'To',
                            timeContainer: 'row',
                        }"
                        :start-error="getErrors(idx)?.from"
                        :end-error="getErrors(idx)?.to"
                    />
                </div>
            </div>
        </div>

        <div class="mt-5 d-flex flex-row" v-if="!fromEditService">
            <button @click="prevStep" class="ml-0 px-3 py-2 d-block btn-new btn-new-outline font-weight-bold">
                Back
            </button>
            <button @click="nextStep" type="submit" class="ml-auto px-4 py-3 d-block btn-new font-weight-bold">Next
            </button>
        </div>
    </div>
</template>

<style scoped>
h2 {
    font-weight: 600;
    margin-bottom: 0;
}

.unavailable {
    color: #999999;
}
</style>
